var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Row',{attrs:{"justify-space-around":""}},[_c('Column',{attrs:{"shrink":""}},[_c('Progress',{attrs:{"radius":_vm.size}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }